import request from '@/utils/request'

// 安全检验报告列表
export function list(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/security/list',
    method: 'get',
    params
  })
}

// 创建安全检验报告
export function create(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/security/create',
    method: 'post',
    data
  })
}

// 安全检验报告详情
export function detail(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/security/detail/${id}`,
    method: 'get'
  })
}

// 更新安全检验报告
export function update(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/security/update',
    method: 'put',
    data
  })
}

// 删除安全检验报告
export function remove(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/security/delete/${id}`,
    method: 'delete'
  })
}

// 审核安全检验报告
export function review(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/security/review',
    method: 'put',
    data
  })
}

// 批准安全检验报告
export function approve(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/security/approve',
    method: 'put',
    data
  })
}
